import { render } from "./AiReviewSuggestionCard.vue?vue&type=template&id=71b4981c"
import script from "./AiReviewSuggestionCard.vue?vue&type=script&lang=js"
export * from "./AiReviewSuggestionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__